module.exports = __webpack_public_path__ + "static/mahh-logo-512-bdbd053f1d7d5e8d21c14d457a4b1f18.png";